<template>
  <div class="popup-container">
    <RouterView />
  </div>
</template>

<script>
export default {
  name: "PopupLayout",
  data() {
    return {};
  },
  computed: {},
  components: {
  },
};
</script>

